import { useRef, useEffect, useCallback, useMemo } from "react";
import {
  Grid,
  Box,
  Text,
  Stack,
  HStack,
  VStack,
  useToast,
  Skeleton,
  IconButton,
  useDisclosure,
  CircularProgress,
} from "@chakra-ui/react";
import { useHistory } from "react-router-dom";
import Button from "../Button/Button";
import ConfirmationModal from "components/Modals/p2p/Confirmation";
import ListingPreview from "components/Modals/p2p/ListingPreview";

import { ReactComponent as Delete } from "assets/svg/delete.svg";
import { ReactComponent as Edit } from "assets/svg/edit.svg";
import { ReactComponent as Hide } from "assets/svg/hide.svg";
import { ReactComponent as Show } from "assets/svg/view.svg";

import {
  useCancelTradeMutation,
  useGetP2PListingUserProfileQuery,
  useHideListingMutation,
} from "services/p2pApi";

import { useGetCoinToUsdRateQuery } from "services/rateApi";

import {
  maybePluralize,
  // secondsToDhms,
  // summarizeTimeNarration,
} from "util/utils";
import toLower from "lodash/toLower";
import toPrecision from "util/toPrecision";
import toCoinLocale from "util/toCoinLocale";
// import DetailItem from "components/DetailItem/DetailItem";
// import { capitalize } from "lodash";
// import { formatDistanceToNow } from "date-fns";
import UserPopover from "components/UserPopover/UserPopover";

export default function P2PListingItem(props) {
  const {
    _id,
    coin,
    dynamic,
    price,
    userId,
    currentUser,
    isFetching,
    userData,
    isOwn,
    hide,
    refetch,
    ratingsRef,
    volume,
    // sourceUnit,
    tradeOption,
    currentVolume,
    paymentOption,
    adsType,
    previewData,
    // destinationUnit,
    currency,
  } = props;
  const toast = useToast();
  const currentCancelVerb = useRef();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isPreviewOpen,
    onOpen: onPreviewOpen,
    onClose: onPreviewClose,
  } = useDisclosure();

  const history = useHistory();

  const [cancelTrade, { isLoading: isCancelling, isSuccess, isError, error }] =
    useCancelTradeMutation();

  const { data: listingOwnerProfile /* isLoading: isLoadingOwnerProfile */ } =
    useGetP2PListingUserProfileQuery(`${userData?.username}`, {
      skip: !userData?.username,
    });

  console.log("Listing Owner Porfile", listingOwnerProfile);

  const ownerProfile = useMemo(
    () => listingOwnerProfile?.profile,
    [listingOwnerProfile]
  );
  // const ownerName = useMemo(
  //   () =>
  //     [
  //       ownerProfile?.userData?.firstName,
  //       ownerProfile?.userData?.lastName,
  //     ].join(" "),
  //   [ownerProfile]
  // );

  // const ownerPresenceColor = useMemo(() => {
  //   const map = {
  //     online: "var(--primary)",
  //     offline: "var(--secondary)",
  //   };

  //   return map[ownerProfile?.presence?.status ?? "online"];
  // }, [ownerProfile]);

  // const ownerReleaseSpeed = useMemo(
  //   () =>
  //     formatDistanceToNow(
  //       new Date(
  //         ((ownerProfile?.releaseSpeed?.timeSum ?? 20030034) /
  //           (ownerProfile?.releaseSpeed?.tradeCounts ?? 20030034)) *
  //           1000 +
  //           Date.now()
  //       ),
  //       {
  //         addSuffix: false,
  //       }
  //     ),
  //   [ownerProfile]
  // );

  console.log("owner time", ownerProfile?.releaseSpeed?.timeSum);

  const [
    hideListing,
    {
      isLoading: isHiding,
      isSuccess: isHidingSuccess,
      isError: ishidingError,
      error: hidingError,
    },
  ] = useHideListingMutation();

  const reMapCoin = (coin) => {
    const map = {
      tbtc: "btc",
      teth: "eth",
      usdt: "usd",
    };
    return map[coin] ?? coin;
  };

  // const unit = (adsType) => {
  //   const map = {
  //     selling: "sourceUnit",
  //     buying: "destinationUnit",
  //   };

  //   return props[map[adsType ?? "selling"]];
  // };

  const { data: coinToUsdData, isFetching: isCheckingCoinToUsdRate } =
    useGetCoinToUsdRateQuery(reMapCoin(coin) ?? "btc", {
      skip: coin?.includes("usd"),
    });

  const unitCost = useMemo(() => {
    if (dynamic)
      return Number(
        (coin?.includes("usd")
          ? 1
          : coinToUsdData?.exchangeRate[
              adsType === "selling" ? "buy" : "sell"
            ]) * price
      );
    return Number(tradeOption?.unitCost);
  }, [dynamic, price, coin, coinToUsdData, adsType, tradeOption?.unitCost]);
  /* eslint-enable */

  console.log("UNIT PRICE", unitCost, coin, currency);

  useEffect(() => {
    if (isSuccess) {
      toast({
        position: "bottom-right",
        title: "Success",
        description: "Listing cancelled successfully",
        status: "success",
        duration: 9000,
        isClosable: true,
      });

      onClose && onClose();
    }
    if (isError && error) {
      console.log("CANCEL LISTING ERROR", error);
      toast({
        position: "bottom-right",
        title: "Oops!!",
        description:
          error?.data?.error ??
          "Unable to cancel your listing, please try again",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }, [isSuccess, isError, error, onClose, toast]);

  useEffect(() => {
    if (isHidingSuccess) {
      toast({
        position: "bottom-right",
        title: "Success",
        description:
          currentCancelVerb.current === "hide"
            ? "Listing hidden successfully"
            : "Listing is now visible",
        status: "success",
        duration: 4000,
        isClosable: true,
      });

      onClose && onClose();
    }
    if (hidingError && ishidingError) {
      toast({
        position: "bottom-right",
        title: "Oops!!",
        description:
          hidingError?.data?.error ??
          (currentCancelVerb.current === "hide"
            ? "Unable to hide listing, please try again"
            : "Failed to unhide listing"),
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  }, [isHidingSuccess, hidingError, ishidingError, onClose, toast]); // Note to Dayo: these dependencies are responsible for the multiple toast warnings

  const paymentMethodColor = useCallback((label) => {
    const map = {
      changera: "#3B5C9D",
      "bitmama wallet": "#04822D",
    };

    return map[toLower(label)] ?? "#F4B740";
  }, []);

  const buttonColors = useMemo(() => {
    const map = {
      selling: {
        color: "white",
        focus: "var(--focusColor)",
        bg: "var(--primary)",
      },
      buying: {
        color: "white",
        focus: "#ED2E7E6f",
        bg: "#ED2E7E",
      },
    };

    return map[toLower(adsType ?? "selling")];
  }, [adsType]);

  return (
    <>
      <ConfirmationModal
        isOpen={isOpen}
        onClose={onClose}
        isLoading={isCancelling}
        onConfirm={() => cancelTrade(_id)}
        title="Confirm"
        buttonText={["No", "Yes, Cancel"]}
      >
        <VStack>
          <Text textAlign="center">
            Are you sure you want to cancel this listing?
          </Text>
        </VStack>
      </ConfirmationModal>

      <ListingPreview
        title="View Listing"
        state={previewData}
        onConfirm={() => onPreviewClose()}
        isOpen={isPreviewOpen}
        // isLoading={isLoading}
        onClose={onPreviewClose}
        buttonText={["Close", "Close"]}
      />

      <Grid
        templateColumns={["1.1fr 2fr 2.5fr 1.5fr 1.4fr"]}
        gap={[".5em"]}
        p={[".5em 0 1em 0"]}
        m={["1em 0"]}
        borderBottom={["0.5px solid #d9dbe9c2"]}
        alignItems="center"
      >
        <Skeleton
          isLoaded={!isFetching}
          maxH={isFetching ? "30px" : "fit-content"}
        >
          <Stack>
            <UserPopover
              user={userData}
              _popver={{ placement: "right-start" }}
            />

            {isOwn && (
              <HStack mt="6px !important">
                <IconButton
                  variant="ghost"
                  size="xs"
                  aria-label="edit button"
                  icon={<Box boxSize="16px" as={Edit} />}
                  _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                  onClick={(e) =>
                    history.push(`/dashboard/p2p/${_id}/edit?step=pricing`)
                  }
                />
                <IconButton
                  variant="ghost"
                  size="xs"
                  aria-label="show trade button"
                  isLoading={isHiding}
                  disabled={isHiding}
                  icon={<Box boxSize="16px" as={hide ? Hide : Show} />}
                  _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                  onClick={async (_e) => {
                    // if (isHiding) return;
                    currentCancelVerb.current = hide ? "unhide" : "hide";
                    // listingToHide.current = _id;
                    await hideListing({
                      tradeId: _id,
                      visibility: hide ? "unhide" : "hide",
                    });
                    await refetch();
                  }}
                />
                <IconButton
                  variant="ghost"
                  size="xs"
                  aria-label="edit button"
                  icon={<Box boxSize="16px" as={Delete} />}
                  _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                  onClick={onOpen}
                />
              </HStack>
            )}
            <HStack mt="6px !important" fontSize=".7em" color="#4E4B66">
              <Text lineHeight="12px">
                {Number(ratingsRef?.combinedTrades || 0)}{" "}
                {maybePluralize(
                  Number(ratingsRef?.combinedTrades || 0),
                  "trade",
                  "s"
                )}
              </Text>
              <Text lineHeight="12px">
                {Number(ratingsRef?.combinedRating?.average || 0).toFixed(2)} ⭐
              </Text>
            </HStack>
          </Stack>
        </Skeleton>

        <Skeleton
          isLoaded={!isFetching || !isCheckingCoinToUsdRate}
          maxH={isFetching ? "30px" : "fit-content"}
        >
          {!isCheckingCoinToUsdRate && (
            <Text fontSize="1em" fontWeight="600" color="#4E4B66">
              {Number(unitCost).toLocaleString()} {toCoinLocale(currency)}
            </Text>
          )}
          {isCheckingCoinToUsdRate && (
            <CircularProgress isIndeterminate color="green.400" size="16px" />
          )}
        </Skeleton>

        <Stack>
          <Skeleton
            isLoaded={!isFetching}
            maxH={isFetching ? "30px" : "fit-content"}
          >
            <HStack>
              <Text fontSize=".7em">Available</Text>
              <Text fontSize="14px">
                {toPrecision(volume.$numberDecimal ?? 0, coin)}
              </Text>
            </HStack>
            <HStack mt="2px !important">
              <Text fontSize=".7em">Range</Text>
              <Text fontSize="14px">
                {toPrecision(tradeOption?.minimumFilling ?? 0, coin)} -{" "}
                {toPrecision(currentVolume?.$numberDecimal ?? 0, coin)}
              </Text>
            </HStack>
          </Skeleton>
        </Stack>

        <Skeleton
          isLoaded={!isFetching}
          maxH={isFetching ? "30px" : "fit-content"}
        >
          <HStack flexWrap="wrap">
            {paymentOption?.map((payment) => (
              <Box
                bg="#F2F3F4"
                borderRadius="8px"
                p=".3em .7em"
                m="2px !important"
              >
                <Text
                  fontSize="xs"
                  fontWeight="400"
                  color={paymentMethodColor(payment?.receivingIntoLabel)}
                >
                  {payment.receivingIntoLabel !== "Changera" &&
                  payment.receivingIntoLabel !== "Bitmama Wallet"
                    ? "Bank Transfer"
                    : payment.receivingIntoLabel}
                </Text>
              </Box>
            ))}
          </HStack>
        </Skeleton>

        <Skeleton
          isLoaded={!isFetching}
          maxH={isFetching ? "30px" : "fit-content"}
          maxW={isFetching ? "120px" : "fit-content"}
        >
          {userId !== currentUser?.userId && (
            <Button
              bg={buttonColors?.bg}
              _focus={{
                shadow: `0 0 0 3px ${buttonColors?.focus}`,
              }}
              _hover={{
                shadow: `0 0 0 3px ${buttonColors?.focus}`,
              }}
              _active={{
                shadow: `0 0 0 3px ${buttonColors?.focus}`,
              }}
              minH="40px"
              minW="120px"
              maxW="120px"
              size="sm"
              onClick={() =>
                history.push(
                  `/dashboard/p2p/${_id}/${
                    adsType === "selling" ? "buy" : "sell"
                  }`
                )
              }
            >
              {adsType === "selling" ? "Buy" : "Sell"}
            </Button>
          )}

          {userId === currentUser?.userId && (
            <Button
              minW="120px"
              maxW="120px"
              maxH="40px"
              fontWeight="normal"
              border={`2px solid ${buttonColors?.bg}`}
              color={buttonColors?.bg}
              bg="transparent"
              _focus={{
                shadow: `0 0 0 3px ${buttonColors?.focus}`,
              }}
              _hover={{
                shadow: `0 0 0 3px ${buttonColors?.focus}`,
              }}
              _active={{
                shadow: `0 0 0 3px ${buttonColors?.focus}`,
              }}
              onClick={onPreviewOpen}
            >
              View Ad
            </Button>
          )}
        </Skeleton>
      </Grid>
    </>
  );
}
